var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 25,
    fill: "#F9B300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1584 30.3123C31.3649 31.0893 30.3729 31.4778 29.1827 31.4778C27.9924 31.4778 26.9922 31.081 26.1821 30.2875C25.3886 29.4939 24.9918 28.5268 24.9918 27.3861C24.9918 26.2454 25.3886 25.2783 26.1821 24.4848C26.9922 23.6913 27.9924 23.2945 29.1827 23.2945C30.3729 23.2945 31.3649 23.6913 32.1584 24.4848C32.9519 25.2618 33.3487 26.2289 33.3487 27.3861C33.3487 28.5434 32.9519 29.5187 32.1584 30.3123ZM26.7525 38.3716L38.0603 25.7991L39.5729 26.6422L28.2403 39.2395L26.7525 38.3716ZM28.042 28.5268C28.3395 28.8244 28.7115 28.9732 29.1579 28.9732C29.6042 28.9732 29.9762 28.8244 30.2738 28.5268C30.5713 28.2127 30.7201 27.8325 30.7201 27.3861C30.7201 26.9398 30.5713 26.5678 30.2738 26.2702C29.9762 25.9727 29.6042 25.8239 29.1579 25.8239C28.7115 25.8239 28.3395 25.9727 28.042 26.2702C27.7609 26.5678 27.6204 26.9398 27.6204 27.3861C27.6204 27.8325 27.7609 28.2127 28.042 28.5268ZM40.54 40.1074C39.7465 40.9009 38.7546 41.2977 37.5643 41.2977C36.374 41.2977 35.3821 40.9009 34.5886 40.1074C33.795 39.3139 33.3983 38.3468 33.3983 37.2061C33.3983 36.0654 33.795 35.0982 34.5886 34.3047C35.3821 33.5112 36.374 33.1144 37.5643 33.1144C38.7546 33.1144 39.7465 33.5112 40.54 34.3047C41.3336 35.0982 41.7303 36.0654 41.7303 37.2061C41.7303 38.3468 41.3336 39.3139 40.54 40.1074ZM36.4484 38.3468C36.746 38.6443 37.1179 38.7931 37.5643 38.7931C38.0107 38.7931 38.3744 38.6361 38.6554 38.322C38.953 38.0079 39.1018 37.6359 39.1018 37.2061C39.1018 36.7597 38.953 36.3877 38.6554 36.0902C38.3744 35.7761 38.0107 35.619 37.5643 35.619C37.1179 35.619 36.746 35.7761 36.4484 36.0902C36.1674 36.3877 36.0268 36.7597 36.0268 37.2061C36.0268 37.6524 36.1674 38.0327 36.4484 38.3468Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_236",
    x: 0.914916,
    y: 0.914916,
    width: 64.1702,
    height: 64.1702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.54254
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5625 0 0 0 0 0.5625 0 0 0 0 0.5625 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_468_236",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcent);
export default __webpack_public_path__ + "static/media/procent.2bca43635a5bc078fb850a09c07c1390.svg";
export { ForwardRef as ReactComponent };